export type TrendChannelState = {
    selectedChannels: Array<{
        id: string;
        channelName: string;
        deviceId: string;
    }>;
    channelsForGraph: number[];
};

export const initialTrendChannelsSelected: TrendChannelState = {
    selectedChannels: [],
    channelsForGraph: [],
};
